declare let THREE: any;

enum Direction {
  top = 'top',
  left = 'left',
  right = 'right',
  bottom = 'bottom'
}

export class ScaleInfo {

  public readonly localScaleDirection = new THREE.Vector3();
  public readonly worldScaleDirection = new THREE.Vector3();
  public readonly planeNormal = new THREE.Vector3();

  private static calculateWorldScaleDirection(object, localScaleDirection) {
    const currentLocalScaleDirection = localScaleDirection.clone();
    object.localToWorld(currentLocalScaleDirection);
    const oppositeDirection = localScaleDirection.clone().negate();
    object.localToWorld(oppositeDirection);
    return currentLocalScaleDirection.sub(oppositeDirection).normalize();
  }

  calculate(object, direction: Direction) {
    this.calculatePlaneNormal(object, direction);
    this.calculateLocalScaleDirection(direction);
    this.calculateWorldScaleDirection(object, direction);
  }

  private calculatePlaneNormal(object, direction: Direction) {
    switch (direction) {
      case 'right':
      case 'left':
        this.planeNormal.set(0, 1, 0);
        break;
      case 'top':
      case 'bottom':
        return object.getWorldDirection(this.planeNormal);
    }
  }

  private calculateLocalScaleDirection(direction: Direction) {
    switch (direction) {
      case 'right':
        this.localScaleDirection.set(1, 0, 0);
        break;
      case 'left':
        this.localScaleDirection.set(-1, 0, 0);
        break;
      case 'top':
        this.localScaleDirection.set(0, 1, 0);
        break;
      case 'bottom':
        this.localScaleDirection.set(0, -1, 0);
        break;
    }
  }

  private calculateWorldScaleDirection(object, direction: Direction) {
    switch (direction) {
      case 'right':
      case 'left':
        this.worldScaleDirection.copy(ScaleInfo.calculateWorldScaleDirection(object, this.localScaleDirection));
        break;
      case 'top':
      case 'bottom':
        this.worldScaleDirection.copy(this.localScaleDirection);
        break;
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/Shared/ObjectResize/ScaleInfo.ts